/* GoGo Solar - hold the favicon, title, description, robots rule AND the
social/search labels on the homepage.

WHY THIS EXISTS

The homepage is the ported React build. On startup it replaces the whole
<head> with its own, and the head it installs points at favicons that do
not exist on this site:

/favicon.ico  /favicon-32.png  /favicon-16.png
/apple-touch-icon.png  /icon-512.png

All five return 404 - Shopify cannot serve files from the site root. So
the homepage asked the browser for an icon that was not there and showed
none at all, while every ordinary page showed the real one. That is why
it looked like there were two different favicons. There was only ever
one file; the homepage was throwing the link away.

It also resets <title> to a bare "GoGo Solar", discarding the search
title. Google reads the served HTML first so the damage is limited, but
its renderer sees the React version, and so does anyone reading the tab.

OG / TWITTER / CANONICAL  (added 13 Oct 2026)
The React head ALSO sets og:title "Bright Solar Lights", the old
"Wireless solar lighting for homes..." og:description, author and
twitter:site "Higgsfield", and drops the canonical link. Google's
renderer read those and showed "Bright Solar Lights" as the homepage
title in search. Hussein does not want the old name anywhere. So the
og:*, twitter:* and canonical tags are now held here too, matching
sections/bsl-home.liquid, and the Higgsfield author tags are removed.

DESC MUST MATCH sections/bsl-home.liquid. The served HTML carries the
description Google reads on its first pass; this constant is what holds
it afterwards. If the two disagree, whichever ran last wins and the
result looks random. Changed 4 Oct 2026 to Hussein's own wording.

ROBOTS / max-image-preview:none  (added 16 Sep 2026)
Google was pulling a large thumbnail into the right of the homepage search
result. Hussein wants only the small favicon beside the site name on the
left, and no big picture on the right. max-image-preview:none removes the
thumbnail. It does NOT affect the favicon, and it does NOT deindex the
page - index,follow is stated explicitly alongside it.
This is set ONLY on the homepage. Product and collection pages keep their
image previews, which help click-through.

So: strip any icon link that is not ours, put ours back, and hold the
title, description, robots rule and social/search labels. Runs on every
mutation plus a short polling window, because React does this after our
scripts have already run.

Only writes when something is actually wrong - otherwise the observer
would retrigger itself forever. */
(function () {
  var ICON = "https://cdn.shopify.com/s/files/1/1011/9715/2638/files/gogosolar-favicon.png?v=1789303674";
  var TITLE = "Solar Street Lights & Security Lighting UK | GoGo Solar";
  var DESC = "Solar lights. Garden, driveway and security lighting that fits in five minutes. No cables. No electrician. No electricity bills.";
  var ROBOTS = "index, follow, max-image-preview:none";
  var URL_HOME = "https://gogosolar.co.uk/";
  var SHARE = "https://cdn.shopify.com/s/files/1/1011/9715/2638/files/gogosolar-share-card.png?v=1789254430";
  var BRAND = "GoGo Solar";
  
  /* name= or property= meta tags we hold to a fixed value */
  var HOLD = [
    ["property", "og:title", TITLE],
    ["property", "og:description", DESC],
    ["property", "og:site_name", BRAND],
    ["property", "og:url", URL_HOME],
    ["property", "og:type", "website"],
    ["property", "og:image", SHARE],
    ["property", "og:locale", "en_GB"],
    ["name", "twitter:title", TITLE],
    ["name", "twitter:description", DESC],
    ["name", "twitter:image", SHARE],
    ["name", "author", BRAND]
  ];
  
  function addLink(rel, sizes) {
    var l = document.createElement("link");
    l.setAttribute("rel", rel);
    l.setAttribute("type", "image/png");
    if (sizes) l.setAttribute("sizes", sizes);
    l.setAttribute("href", ICON);
    document.head.appendChild(l);
  }
  
  function setMeta(name, value) {
    var m = document.querySelector('meta[name="' + name + '"]');
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", name);
      m.setAttribute("content", value);
      document.head.appendChild(m);
    } else if (m.getAttribute("content") !== value) {
      m.setAttribute("content", value);
    }
  }
  
  /* Hold one tag per key: fix the first, remove any duplicates. */
  function holdTag(attr, key, value) {
    var all = document.querySelectorAll("meta[" + attr + '="' + key + '"]');
    if (!all.length) {
      var m = document.createElement("meta");
      m.setAttribute(attr, key);
      m.setAttribute("content", value);
      document.head.appendChild(m);
      return;
    }
    if (all[0].getAttribute("content") !== value) all[0].setAttribute("content", value);
    for (var i = 1; i < all.length; i++) {
      if (all[i].parentNode) all[i].parentNode.removeChild(all[i]);
    }
  }
  
  function ensure() {
    if (!document.head) return;
    
    var links = document.querySelectorAll(
      'link[rel~="icon"],link[rel="apple-touch-icon"],link[rel="shortcut icon"],link[rel="mask-icon"]'
    );
    var haveIcon = false;
    var haveApple = false;
    
    for (var i = 0; i < links.length; i++) {
      var l = links[i];
      var rel = l.getAttribute("rel") || "";
      if (l.getAttribute("href") === ICON) {
        if (rel.indexOf("apple") > -1) haveApple = true;
        else haveIcon = true;
        continue;
      }
      if (l.parentNode) l.parentNode.removeChild(l);
    }
    
    if (!haveIcon) addLink("icon", "512x512");
    if (!haveApple) addLink("apple-touch-icon", null);
    
    if (document.title !== TITLE) document.title = TITLE;
    
    setMeta("description", DESC);
    setMeta("robots", ROBOTS);
    
    for (var h = 0; h < HOLD.length; h++) holdTag(HOLD[h][0], HOLD[h][1], HOLD[h][2]);
    
    /* twitter:site / creator pointed at the builder, not the shop */
    var junk = document.querySelectorAll('meta[name="twitter:site"],meta[name="twitter:creator"]');
    for (var j = 0; j < junk.length; j++) {
      if (junk[j].parentNode) junk[j].parentNode.removeChild(junk[j]);
    }
    
    /* canonical - React drops it */
    var canon = document.querySelectorAll('link[rel="canonical"]');
    if (!canon.length) {
      var c = document.createElement("link");
      c.setAttribute("rel", "canonical");
      c.setAttribute("href", URL_HOME);
      document.head.appendChild(c);
    } else {
      if (canon[0].getAttribute("href") !== URL_HOME) canon[0].setAttribute("href", URL_HOME);
      for (var k = 1; k < canon.length; k++) {
        if (canon[k].parentNode) canon[k].parentNode.removeChild(canon[k]);
      }
    }
  }
  
  ensure();
  new MutationObserver(ensure).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener("DOMContentLoaded", ensure);
  window.addEventListener("load", ensure);
  
  /* React can swap the head a moment after load, past the last event we get,
  so keep checking briefly rather than trusting a single pass */
  var n = 0;
  var t = setInterval(function () {
    ensure();
    if (++n > 30) clearInterval(t);
  }, 500);
})();
